import { createStorage } from '~tools/createStorage';
export var storage = createStorage('speedlo-waiter');